import "../../styles/Components/home-image-slider.scss";

const init = () => {
  $(document).ready(() => {
    // initialize slick desktop slider
    $(".slick-home").slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      dots: true,
      prevArrow:
      '<svg class="slick-prev-new" viewBox="0 0 56 55" height="50"><ellipse fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" stroke="#D8D8D8" cx="27.7" cy="27.3" rx="27" ry="26.5"/><polygon fill-rule="evenodd" clip-rule="evenodd" fill="#575757" points="16.1,27.8 24.6,35.8 23.9,36.5 14.2,27.3 23.9,18.1 24.6,18.8 16.1,26.9 41.2,26.9 41.2,27.8 "/></svg>',
      nextArrow:
      '<svg class="slick-next-new" viewBox="0 0 56 55" height="50"><ellipse fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" stroke="#D8D8D8" cx="28" cy="27.5" rx="27" ry="26.5"/><polygon fill-rule="evenodd" clip-rule="evenodd" fill="#575757" points="40.2,27.6 31.7,35.7 32.4,36.3 42,27.1 32.4,18 31.7,18.6 40.2,26.7 15,26.7 15,27.6 "/></svg>',
    });
    // initialize slick mobile slider
    $(".slick-home-mobile").slick({
      infinite: true,
      arrows: false,
      dots: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 4000
    });
    $(".home-products-carousel").slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      adaptiveHeight: false,
      mobileFirst: true,
      dots: true,
      arrows: false,
      prevArrow:
      '<svg class="slick-prev-new" viewBox="0 0 56 55" height="50"><ellipse fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" stroke="#D8D8D8" cx="27.7" cy="27.3" rx="27" ry="26.5"/><polygon fill-rule="evenodd" clip-rule="evenodd" fill="#575757" points="16.1,27.8 24.6,35.8 23.9,36.5 14.2,27.3 23.9,18.1 24.6,18.8 16.1,26.9 41.2,26.9 41.2,27.8 "/></svg>',
      nextArrow:
      '<svg class="slick-next-new" viewBox="0 0 56 55" height="50"><ellipse fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF" stroke="#D8D8D8" cx="28" cy="27.5" rx="27" ry="26.5"/><polygon fill-rule="evenodd" clip-rule="evenodd" fill="#575757" points="40.2,27.6 31.7,35.7 32.4,36.3 42,27.1 32.4,18 31.7,18.6 40.2,26.7 15,26.7 15,27.6 "/></svg>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            arrows: true,
            dots: false
          }
        }
      ]
    });
  });
};

export default init()
